import { createI18n } from "vue-i18n";
import en from '../assets/languages/en.json';
import fr from '../assets/languages/fr.json';

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: "en",
    inheriteLocale: true,
    messages: {
        en,
        fr,
    },
})

export default i18n